import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CmsContentService } from './cms-content.service';
import { Recommendation } from '../interfaces/recommendation';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RecommendationService {

  constructor(private cms: CmsContentService, @Inject(LOCALE_ID) private locale: string) { }

  getRecommendation(key: string): Observable<Recommendation> {
    return this.cms.getByKey(key, this.locale, 'Recommendation').pipe(
      map((item) => {

        if (item) {
          return {
            key: item.key,
            header: item.heading,
            text: item.text,
            img_alt: item.imageAlt,
            link_text: item.linkText,
            link_url: item.linkUrl,
            link_type: item.linkType || "external",
            img_url: item.imageUrl
          } as Recommendation;
        }

        return {
          key: "key",
          header: "heading",
          text: "text",
          link_text: "link_text",
          link_url: "link_url",
          link_type: "type",
          img_url: ""
        } as Recommendation;
      })
    );
  }

  getRecommendationKeysForRisk(risk: number): Observable<string[]> {
    return this.cms.getRiskRecommendations().pipe(
      map(items => items.find(i => i.risk === risk)?.keys ?? [])
    );
  }
}
